import React from "react";
import { /* Button, */ Form } from "react-bootstrap";
import { ReactComponent as CloseButton } from "assets/svg/outline-cross.svg";
import { ReactComponent as OutlinePlus16 } from "assets/svg/outline-plus-16.svg";
import IconButton from "components/icon-button";
import CustomSelect from "components/custom-select/CustomSelect";
import { useUser } from "contexts/UserContext";
import { useSubscription } from "contexts/subscription-context";
import addOrEditSessionStyles from "../../AddOrEditSession.module.scss";

export type MeetingType = "orchid" | "external" | "zoom";

const LOCATION_OPTIONS_WITH_ZOOM = [
  {
    label: "Orchid Video Room",
    value: "orchid",
  },
  {
    label: "Zoom",
    value: "zoom",
  },
  {
    label: (
      <span className={addOrEditSessionStyles["add-external-link-label"]}>
        <OutlinePlus16 />
        Add external link
      </span>
    ),
    value: "external",
  },
];

const LOCATION_OPTIONS_WITHOUT_ZOOM = [
  {
    label: "Orchid Video Room",
    value: "orchid",
  },
  {
    label: (
      <span className={addOrEditSessionStyles["add-external-link-label"]}>
        <OutlinePlus16 />
        Add external link
      </span>
    ),
    value: "external",
  },
];

interface LocationSelectorProps {
  telehealth: boolean;
  meetingType: MeetingType;
  externalLink: string;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
  setExternalLink: React.Dispatch<React.SetStateAction<string>>;
  setMeetingType: React.Dispatch<MeetingType>;
  trackClick: (elementName: string) => void;
  disabled?: boolean;
  zoomIntegrated?: boolean;
}

const LocationSelector = ({
  telehealth,
  meetingType,
  externalLink,
  setIsDirty,
  setExternalLink,
  setMeetingType,
  trackClick,
  disabled,
  zoomIntegrated,
}: LocationSelectorProps) => {
  const { user } = useUser();
  const { restrictAccessToPaidFeature } = useSubscription();

  // const handleLocationDropdownSelect = useCallback(
  //   (eventKey: string | null) => {
  //     trackClick("location-dropdown");
  //     if (!eventKey) {
  //       return;
  //     }
  //     setIsDirty(true);
  //     setMeetingType(eventKey as MeetingType);
  //   },
  //   [trackClick, setIsDirty, setMeetingType],
  // );

  //TODO: add location dropdown instead of the old UI below

  return (
    //     <label className={addToCalendarStyles["label"]}>
    //     <span className={addToCalendarStyles["label-text"]}>
    //       {messages.location}
    //     </span>

    //     <DropdownToggle
    //       title={<input type="text" placeholder="Enter location" />}
    //       onSelect={handleLocationDropdownSelect}
    //     >
    //       <Dropdown.Item eventKey="orchid">
    //         {messages.orchidTelehealth}
    //       </Dropdown.Item>
    //       <Dropdown.Item
    //         eventKey="external"
    //         disabled={restrictAccessToPaidFeature(user)}
    //       >
    //         {messages.enterExternalUrl}
    //       </Dropdown.Item>
    //     </DropdownToggle>
    //     </label>

    <div className={"d-block"}>
      {!telehealth && (
        <Form.Group className={"mb-0"}>
          <Form.Label className={"rg-12 gray01 mb-1"}>Location</Form.Label>
          <p className={"mb-0"}>11 - Office</p>
        </Form.Group>
      )}

      {telehealth &&
        (meetingType === "external" || !!externalLink ? (
          <div>
            <div className="mb-1 rg-12 gray01">External link URL</div>
            <div className={addOrEditSessionStyles["external-link"]}>
              <Form.Group className={"w-100 mb-0"}>
                <Form.Control
                  type="text"
                  placeholder="Enter external link"
                  name="external_link"
                  value={externalLink || ""}
                  onChange={(event) => {
                    setIsDirty(true);
                    setExternalLink(event.currentTarget.value);
                  }}
                  onClick={() => trackClick("external-link-field")}
                  disabled={disabled}
                />
              </Form.Group>
              <span className={"ml-2"}>
                <IconButton
                  onClick={() => {
                    trackClick("close-button");
                    setMeetingType("orchid");
                  }}
                >
                  <CloseButton />
                </IconButton>
              </span>
            </div>
          </div>
        ) : (
          // <Button
          //   variant="link"
          //   className="p-0 d-flex align-items-center"
          //   onClick={() => {
          //     trackClick("add-external-link-button");
          //     setMeetingType("external");
          //   }}
          //   disabled={restrictAccessToPaidFeature(user) || disabled}
          // >
          //   <OutlinePlus16 className="mr-1" /> Add external link
          // </Button>
          <Form.Group className={"mb-0"}>
            <Form.Label className={"rg-12 gray01 mb-1"}>Location</Form.Label>
            <CustomSelect
              disabled={restrictAccessToPaidFeature(user) || disabled}
              options={
                !zoomIntegrated
                  ? LOCATION_OPTIONS_WITHOUT_ZOOM
                  : LOCATION_OPTIONS_WITH_ZOOM
              }
              onChange={(el) => {
                setIsDirty(true);
                trackClick("add-external-link-button");
                setMeetingType(el.value as MeetingType);
              }}
              required
              value={
                !zoomIntegrated
                  ? LOCATION_OPTIONS_WITHOUT_ZOOM.find(
                      (option) => option.value === meetingType,
                    )
                  : LOCATION_OPTIONS_WITH_ZOOM.find(
                      (option) => option.value === meetingType,
                    )
              }
            />
          </Form.Group>
        ))}
    </div>
  );
};

export default LocationSelector;
